import { showToast } from '@banno/jha-wc/src/js/utils/toast-util';
import { Injectable } from '@jack-henry/frontend-utils/di';
import { LoggingService } from '@treasury/core/logging';
import { TmToastPosture } from './tm-toast.service.types';

/**
 * A service for creating toasts, wrapping the jha-wc `showToast` function.
 */
@Injectable()
export class TmToastService {
    constructor(private readonly loggingService: LoggingService) {}

    public show(message: string, posture: TmToastPosture = TmToastPosture.Success, log = false) {
        if (log) {
            this.loggingService.logError(message);
        }
        showToast({ message, role: posture });
    }
}
